
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiReorderGoogle as ObiReorderGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-reorder-google.js';
 
 
 

 
 export const ObiReorderGoogle = createComponent({
   react: React,
   tagName: 'obi-reorder-google',
   elementClass: ObiReorderGoogleElement,
   events: {
     
   }
  });
 
 